'use strict';

angular.module('helpers.mail', [])

.factory('Mailto', [function () {
    var api = {};

    /**
	 * Returns a URL for a mailto-link
	 * @param  {String} recipient    - Recipient email address
	 * @param  {Object} opts         - Options to construct the URL
	 * @param  {String} opts.cc      - Cc recepient email address (optional)
	 * @param  {String} opts.bcc     - Bcc recepient email address (optional)
	 * @param  {String} opts.subject - Email subject (optional)
	 * @param  {String} opts.body    - Email body (optional). Separate lines with the newline character (\n)
	 * @return {String}              - Returns the URL to put into the href-attribute of a mailto link
	 */
    api.url = function (recipient, opts) {
        var link = 'mailto:';
        link += window.encodeURIComponent(recipient);
        var params = [];
        angular.forEach(opts, function (value, key) {
            params.push(key.toLowerCase() + '=' + window.encodeURIComponent(value));
        });
        if (params.length > 0) {
            link += '?' + params.join('&');
        }
        return link;
    };

    return api;
}]);

